// Icon picker component
import React from 'react';
import { CATEGORY_ICONS } from '../utils/categoryIcons';

const IconPicker = ({ value, onChange, label = 'Icon' }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className="grid grid-cols-5 gap-2">
        {CATEGORY_ICONS.map((icon) => (
          <button
            key={icon.emoji}
            type="button"
            onClick={() => onChange(icon.emoji)}
            className={`p-3 text-2xl rounded-lg border-2 transition-all hover:scale-110 ${
              value === icon.emoji
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 hover:border-gray-300'
            }`}
            title={icon.label}
          >
            {icon.emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

export default IconPicker;
